import { actionCreatorFactory } from 'typescript-fsa'
import { OrderStatus } from '../../../models/order'

const actionCreator = actionCreatorFactory()

export const changeOrderStatus = actionCreator<OrderStatus>('ORDER_STATUS_CHANGE')
